<template>
  <el-container :style="{ background: APP_ELEMENT_COLOR }">
    <!--导航-->
    <el-aside :class="{ collapsed: isCollapse }" v-if="sideData">
      <div class="title" :class="{ collapsed: isCollapse }">
        <img class="logo" src="@/assets/logo.svg" />
        <template v-if="!isCollapse">
          <span class="name">{{ APP_TITLE }}</span>
          <span class="version">{{ APP_VERSION }}</span>
        </template>
      </div>
      <side-bar ref="sideBar" :rows="sideData" :basePath="basePath" :isCollapse="isCollapse" :backgroundcolor="APP_ELEMENT_COLOR" activetextcolor="#FFD04B" textcolor="#F2F6FC" />
    </el-aside>
    <el-container style="min-width: 800px;">
      <!--栏目-->
      <el-header>
        <div class="navbar">
          <i class="item" :class="{ collapsed: isCollapse }" @click="toggleSideBar">
            <i class="el-icon-s-fold" />
          </i>
          <!--面包屑-->
          <el-breadcrumb separator="/">
            <el-breadcrumb-item v-for="(item, index) in $route.matched" :key="index">{{ item.meta.title }}</el-breadcrumb-item>
            <router-link target="_blank" :to="{ path: $route.fullpath }">新页面打开 </router-link>
          </el-breadcrumb>
        </div>
        <router-link class="item el-icon-message" :to="{ path: '/message' }" />
        <current class="item" />
      </el-header>

      <!--正文-->
      <el-main>
        <router-view :key="$route.path" />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  components: {
    SideBar: () => import('./navbar/sider'),
    current: () => import('@/views/system/user/current'),
  },
  data () {
    return {
      APP_TITLE: process.env.VUE_APP_TITLE,
      APP_ELEMENT_COLOR: process.env.VUE_APP_ELEMENT_COLOR,
      APP_VERSION: process.env.VUE_APP_VERSION,
      basePath: this.$route.matched[0].path,
      menus: null,
      sideData: null,
      isCollapse: false,
      loading: true
    }
  },
  created () {
    //获取菜单
    let matche = this.$route.matched[0].path
    this.sideData = this.$router.options.routes.filter(
      (m) => m.path == matche
    )[0].children
  },
  methods: {
    //菜单折叠
    toggleSideBar () {
      this.isCollapse = !this.isCollapse
    },
  }
}
</script>

<style lang="scss" scoped>
.el-container {
  height: 100%;
  overflow: hidden;
}
:deep(.el-header) {
  background: #fff;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  height: 45px;
  height: unset;
  padding: 0;
  .navbar {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    .el-icon-s-fold {
      font-size: 18px;
    }

    .el-menu {
      background: unset;
      border: none;
    }
  }

  .item {
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 0 20px;
    &:hover {
      background: rgba($color: #000, $alpha: 0.1);
    }
  }
}
:deep(.el-aside) {
  display: flex;
  flex-direction: column;
  width: 300px !important;
  overflow: hidden;
  .title {
    color: #fff;
    width: 100%;
    display: flex;
    align-items: center;
    height: 60px;
    padding: 17px;
    margin-bottom: 5px;
    .logo {
      width: 30px;
    }
    .name {
      font-size: 18px;
      margin: 0 10px;
      word-break: keep-all;
    }
    .version {
      transform: skewX(-10deg);
      font-weight: normal;
      background: #d92242;
      border-radius: 5px;
      font-size: 10px;
      padding: 3px 5px;
      margin-top: 2px;
    }
  }
}

:deep(.el-main) {
  padding: 16px;
  background: #f2f6fc;
}
.collapsed {
  width: 64px !important;
  justify-content: center;
  .el-icon-s-fold::before {
    content: '\e7bc';
  }
}
</style>